import Vue from 'vue';
import Component from 'vue-class-component';
import { CORE_ROUTES } from '@/core/core.router';
import { Prop } from 'vue-property-decorator';
import EdNav from '../ed-nav/ed-nav.vue';
import EdLanguage from '../ed-language/ed-language.vue';
import EdAuthPopup from '@/auth/components/ed-auth-popup/ed-auth-popup.vue';
import { Capacitor } from '@capacitor/core';

@Component({
  name: 'ed-header-out-session',
  components: {
    EdNav,
    EdLanguage,
    EdAuthPopup
  }
})
export default class EdHeaderOutSession extends Vue {

  @Prop() readonly sidebarMenu: boolean;

  get canReload() {
    return Capacitor.isNativePlatform();
  }

  /* Methods */
  goHome() {
    this.$router.push({ name: CORE_ROUTES.PUBLIC.HOME.NAME })
  }

  reloadWindow() {
    location.reload();
  }

}
